import React from "react";
import { Helmet } from "react-helmet";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import "../../../../styles/Pages/Financial/Accountant/Liabilities/Liabilities.style.css";
import LiabilitiesLineChart from "../../../../components/PagesComponents/Financial/Accountant/Liabilities/LiabilitiesLineChart.component";
import LiabilitiesPieChart from "../../../../components/PagesComponents/Financial/Accountant/Liabilities/LiabilitiesPieChart.component";
import LiabilityListItem from "../../../../components/PagesComponents/Financial/Accountant/Liabilities/LiabilityListItem.component";
import ListOfLiabilities from "../../../../components/PagesComponents/Financial/Accountant/Liabilities/ListOfLiabilities.component";
import Modal from "../../../../components/Universal/Modal.component";
import AddLiabilitiesModel from "../../../../components/PagesComponents/Financial/Accountant/Liabilities/AddLiabilitiesModel.component";

const Body = ({
  donutChartData,
  lineChartData,
  shortTermLiabilities,
  longTermLiabilities,
  listOfLiabilities,
  addLiabilitiesModal,
  setAddLiabilitiesModal,
}) => {
  return (
    <section className="accountentLiabilities">
      <Helmet>
        <title>Liablities</title>
        <meta
          name="description"
          content="A powerful organization management system to streamline workflows and improve efficiency."
        />
        <meta
          name="keywords"
          content="organization management, workflow automation, business management, employee tracking"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <Modal
        isOpen={addLiabilitiesModal}
        onClose={() => setAddLiabilitiesModal(false)}
      >
        <AddLiabilitiesModel />
      </Modal>
      <PageHeader title={"Main stream liablities"} />
      <div className="mainLiabilitiesContainer">
        <div className="liabilitiesContainer">
          <div className="liabilitiesGraph">
            <LiabilitiesLineChart graphData={lineChartData} />
          </div>
          <div className="liabilitiesPieChart">
            <LiabilitiesPieChart donutChartData={donutChartData} />
          </div>
        </div>
        <div className="liabilitiesInfoContainer">
          <div className="shortAndLongTermLiabilities">
            <div className="shortTermLiabilities">
              <h3>Short-term Liability</h3>
              <div className="scroll-y" style={{ maxHeight: "350px" }}>
                {shortTermLiabilities.map((item) => (
                  <LiabilityListItem listData={item} />
                ))}
              </div>
            </div>
            <div className="longTermLiabilities">
              <h3>Long-term Liability</h3>
              <div className="scroll-y" style={{ maxHeight: "350px" }}>
                {longTermLiabilities.map((item) => (
                  <LiabilityListItem listData={item} />
                ))}
              </div>
            </div>
          </div>
          <div className="listOfLiabilities">
            <div className="title">
              <h3>List of Liabilities</h3>
              <button
                onClick={() => setAddLiabilitiesModal(true)}
                className="actionBtn"
              >
                ADD
              </button>
            </div>
            <ListOfLiabilities listOfLiabilities={listOfLiabilities} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Body;
